/* eslint-disable no-underscore-dangle */

import { truncate } from './string';

const displayGrades = (grades) => {
  return grades && grades.length ? grades.map((grade) => parseInt(grade, 10)).join(', ') : null;
};

const displayPeriods = (periods) => {
  return periods && periods.length ? periods.join(', ') : null;
};

const displayDate = (date) => {
  if (date && date._seconds) {
    const parsedDate = new Date(date._seconds * 1000);

    return parsedDate.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  return null;
};

const displayLocation = (city, state) => {
  if (city && state) {
    return `${city}, ${state}`;
  }

  if (city && !state) {
    return city;
  }

  if (!city && state) {
    return state;
  }

  return null;
};

const displayCompletedSkills = (completed) => {
  return completed ? 'yes' : 'no';
};

const displayName = (student) => {
  if (student.consumer && student.consumer.givenName && student.consumer.familyName) {
    return truncate(`${student.consumer.givenName} ${student.consumer.familyName}`);
  }

  return truncate(student.username);
};

const displayClassCode = (code) => {
  return code.toUpperCase();
};

const isTeacherPrimary = (teacher, classroom) => {
  return teacher.id && classroom.primaryTeacher && teacher.id === classroom.primaryTeacher;
};

function yearsForClassroomReducer(state, action) {
  const classrooms = action.data;
  return classrooms.reduce((years, classroom) => {
    const year = classroom?.primaryTerm?.schoolYear;
    if (year && !years.includes(year)) {
      years.push(year);
    }
    const sortedYears = years.sort((a, b) => b - a);

    return sortedYears;
  }, []);
}

const DASHBOARD_TYPE_MANUAL = 'manual';
const DASHBOARD_TYPE_CLEVER = 'clever';

export {
  displayCompletedSkills,
  displayDate,
  displayGrades,
  displayLocation,
  displayPeriods,
  displayName,
  displayClassCode,
  isTeacherPrimary,
  yearsForClassroomReducer,
  DASHBOARD_TYPE_MANUAL,
  DASHBOARD_TYPE_CLEVER,
};
